import PGlobal from './PGlobal';
import AudioDail from './AudioDail';
import AudioSteps from './AudioSteps';
import AudioTrks, {AUDIO_TRK_HEIGHT} from './AudioTrks';
import Rect from './component/Rect';
import ScrollerBar from "./component/ScrollerBar"
import {STEPLINE_HEIGHT} from "./Timeline"
import Scroller from './component/Scroller';
import {UIEvent} from './const/Event';
import AudioConst from './AudioConst';
import Keyboard from './keyboard';

const WIDTH_EACH_SEC = 36;
const ICON_W = 20;

export default class AudioLine extends PIXI.Container {
    constructor(data) {
        super();

        this.data = data;
        this.data.on("playIndex", this.setSelectedStep, this);
        this.fixedW = 0;
        this.fixedH = 0;
        this.isDailDragging = false;
        this.onChange = null;
        this.onTimeChange = null;

        this.scroller = new Scroller();
        this.scroller.x = 20;
        this.scroller.paddings = [0, 0, 0, 20];
        this.addChild(this.scroller);

        this.dail = new AudioDail();
        this.dail.interval = WIDTH_EACH_SEC;
        this.scroller.addChild(this.dail);

        this.steps = new AudioSteps();
        this.steps.interval = WIDTH_EACH_SEC;
        this.scroller.addChild(this.steps);
        this.steps.onChange = (index) => {
            if(this.onChange) {
                this.onChange(index);
            }
        }

        // 创建3条音轨：BGM、VOICE、SOUND_EFFECT
        this.bgmTrks = new AudioTrks(0);
        this.bgmTrks.interval = WIDTH_EACH_SEC;
        this.scroller.addChild(this.bgmTrks);

        this.voiceTrks = new AudioTrks(1);
        this.voiceTrks.interval = WIDTH_EACH_SEC;
        this.scroller.addChild(this.voiceTrks);

        this.soundTrks = new AudioTrks(2);
        this.soundTrks.interval = WIDTH_EACH_SEC;
        this.scroller.addChild(this.soundTrks);

        // 当前激活的音轨索引：0=BGM, 1=VOICE, 2=SOUND_EFFECT
        this.activeTrkIndex = 1;
        this.allTrks = [this.bgmTrks, this.voiceTrks, this.soundTrks];
        this.trkNames = ['背景音', '配音', '旁白'];

        // 初始化时只显示BGM音轨
        this._updateTrkVisibility();

        // 注册快捷键：1、2、3切换音轨，上下方向键循环切换
        this.key1 = new Keyboard(49); // 数字键1
        this.key1.release = () => {if(PGlobal.hasFocus) this.switchToTrk(0);};
        this.key2 = new Keyboard(50); // 数字键2
        this.key2.release = () => {if(PGlobal.hasFocus) this.switchToTrk(1);};
        this.key3 = new Keyboard(51); // 数字键3
        this.key3.release = () => {if(PGlobal.hasFocus) this.switchToTrk(2);};
        this.keyUp = new Keyboard(38); // 向上方向键
        this.keyUp.release = () => {if(PGlobal.hasFocus) this.switchToPrevTrk();};
        this.keyDown = new Keyboard(40); // 向下方向键
        this.keyDown.release = () => {if(PGlobal.hasFocus) this.switchToNextTrk();};

        this.scroller.on(UIEvent.SCROLL_H, this.onScroll, this);

        this.pointer = new PIXI.Sprite();
        let texture = PGlobal.resources.mainUI.textures['frame'];
        this.pointer.texture = texture;
        this.pointer.pivot.x = Math.floor(this.pointer.width / 2);
        this.scroller.addChild(this.pointer);

        this.scrollerBar = new ScrollerBar();
        this.addChild(this.scrollerBar);
        this.scrollerBar.on(UIEvent.PERCENT_CHANGED, (percent)=>{this.onPercentChanged(percent)}, this);

        this.interactive = true;
        this.on('mousedown', (e) => this.onMouseDown(e));
        this.on('mouseup', (e) => this.onMouseUp(e));
        this.on('mousemove', (e) => this.onMouseMove(e));
        this.on('mouseupoutside', (e) => this.onMouseUp(e));

        this._initBg();
   }

    // 切换到指定音轨
    switchToTrk(index) {
        if(index < 0 || index >= this.allTrks.length) return;
        if(this.activeTrkIndex === index) return;
        
        this.activeTrkIndex = index;
        this._updateTrkVisibility();
        this._updateTrkLabel();
        console.log('切换到音轨: index:=', index, ', name:=', this.trkNames[index]);
        
        // 发送音轨切换消息到Scene
        PGlobal.m.send(SCENE, 6, 36, new proto.com.proto.s.MInt32([index]));
    }

    // 切换到下一条音轨（向下方向键）
    switchToNextTrk() {
        const nextIndex = (this.activeTrkIndex + 1) % this.allTrks.length;
        this.switchToTrk(nextIndex);
    }

    // 切换到上一条音轨（向上方向键）
    switchToPrevTrk() {
        const prevIndex = (this.activeTrkIndex - 1 + this.allTrks.length) % this.allTrks.length;
        this.switchToTrk(prevIndex);
    }

    // 根据消息自动切换音轨（当某条音轨被修改时）
    switchToTrkByType(type) {
        // type: 0=BGM, 1=VOICE, 2=SOUND_EFFECT
        this.switchToTrk(type);
    }

    // 更新音轨可见性
    _updateTrkVisibility() {
        this.allTrks.forEach((trk, index) => {
            if(index!=this.activeTrkIndex && trk.visible) {
                // 原来的音轨取消所有选择
                trk.unselectAll();
            }
            trk.visible = (index === this.activeTrkIndex);
        });
    }

    // 更新音轨标签
    _updateTrkLabel() {
        if(this.trkLabel) {
            this.trkLabel.text = this.trkNames[this.activeTrkIndex];
        }
    }

   _initBg(){
        var bgRectOptions = {
            fillColor:0x3D3D3D
        }
        this.rightBgRect = new Rect(bgRectOptions);
        this.addChildAt(this.rightBgRect, 0);
        this.iconBgRect = new Rect(bgRectOptions);
        this.addChild(this.iconBgRect);

        // 创建3条分割线
        this.splitLine1 = new PIXI.Graphics;
        this.addChild(this.splitLine1);
        
        this.splitLine2 = new PIXI.Graphics;
        this.addChild(this.splitLine2);
        
        this.splitLine3 = new PIXI.Graphics;
        this.addChild(this.splitLine3);

        let y = AudioConst.DAIL_H;
        this.rightBgRect.x = 0;
        this.rightBgRect.y = y;
        this.iconBgRect.x = 0;
        this.iconBgRect.y = y;
        this.steps.y = y;

        y += AudioConst.AUDIO_STEP_H;
        this.splitLine1.y = y;
        this._addIcon("track_animation", 10, this.rightBgRect.y + AudioConst.AUDIO_STEP_H / 2)

        y += AudioConst.AUDIO_SPLIT_LINE_H;
        // 3条音轨使用相同的Y坐标，通过visible控制显示
        this.bgmTrks.y = y;
        this.voiceTrks.y = y;
        this.soundTrks.y = y;
        
        // 添加音轨图标并设置点击事件
        this.trackSoundIcon = this._addIcon("track_sound", 10, y + AudioConst.AUDIO_TRK_H / 2);
        this.trackSoundIcon.interactive = true;
        this.trackSoundIcon.buttonMode = true;
        this.trackSoundIcon.on('click', this._onTrackIconClick.bind(this));
        this.trackSoundIcon.on('tap', this._onTrackIconClick.bind(this));

        this.trkLabel = new PIXI.Text('背景音', new PIXI.TextStyle({
            fontSize: 8,
            fontFamily: 'Arial',
            fill: 0xFFFFFF,
            align: 'center',
            alpha: 0.5
        }));
        this.trkLabel.x = 25;
        this.trkLabel.y = y + AudioConst.AUDIO_TRK_H / 2;
        this.addChild(this.trkLabel);
        this._updateTrkLabel();

        y += AudioConst.AUDIO_TRK_H;
        this.splitLine2.y = y;
        this.splitLine3.y = y; // 第2、3条分割线不再需要，但保留以备后用
   }

    setStepData(data) {
        this.steps.setData(data);
        this._updateScrollerInnerSize();
    }

    setTrkData(data) {
        if(data.trk) {
            data.trks = JSON.parse(data.trk);
            if(data.trks) {
                if(data.trks.type === 0) {
                    this.bgmTrks.setData(data);
                }else if(data.trks.type === 1) {
                    this.voiceTrks.setData(data);
                }else if(data.trks.type === 2) {
                    this.soundTrks.setData(data);
                }else {
                    this.bgmTrks.setData(data);
                }
                // 如果指定了修改的音轨类型，自动切换到该音轨
                if(data.trks.type !== undefined && data.trks.type !== null) {
                    this.switchToTrkByType(data.trks.type);
                }
            }
        }
        this._updateScrollerInnerSize();
    }

    _updateScrollerInnerSize(){
        const maxWidth = Math.max(
            this.steps.getTotalWidth(), 
            this.bgmTrks.getWidth(),
            this.voiceTrks.getWidth(),
            this.soundTrks.getWidth()
        );
        this.scroller.viewport.width = maxWidth;
        this._updateScrollerBar();
    }

    setSelectedStep(index) {
        if(index === null){ return;}
        this.steps.selected = index;
        this.moveToSelected();
    }

    onMouseDown(e) {
        let p = e.data.getLocalPosition(this.dail);
        if(p.y < this.steps.y) {
            this.isDailDragging = true;
            let time = p.x / WIDTH_EACH_SEC;
            this.changeTime(time);
        }
    }

    onMouseUp(e) {
        if(this.isDailDragging) {
            this.isDailDragging = false;
        }
    }

    onMouseMove(e) {
        if(this.isDailDragging) {
            let p = e.data.getLocalPosition(this.dail);
            let time = p.x / WIDTH_EACH_SEC;
            time = Math.max(time, 0);
            this.changeTime(time);
        }
    }

    onPercentChanged(percent){
        this.scroller.scrollerToPercentH(percent);
    }

    changeTime(time) {
        if(this.onTimeChange) {
            this.onTimeChange(time);
        }
    }

    setTime(time) {
        this.pointer.x = Math.floor(time * WIDTH_EACH_SEC);
    }

    moveToSelected() {
        let p = this.steps.getSelectedPosition();
        this._doScroll(p - this.scroller.width / 2);
    }

    _doScroll(p){
        let total = this.scroller.viewport.width;
        const max = Math.max(total - this.scroller.width, 0);
        p = Math.floor(p + 0.5);
        if(p < 0){
            p = 0;
        } else if(p > max) {
            p = max;
        }
        if(this.tween) {
            this.tween.kill();
            this.tween = null;
        }
        if(p != this.scroller.scrollH) {
            this.tween = new TweenLite(this.scroller, 0.5, {scrollH: p, onComplete: () => this.onScroll()});
        }
    }

    onScroll(){
        this._updateDrawRange();
        this._updateScrollerBar();
    }

    _updateDrawRange(){
        const visibleMin = Math.max(this.scroller.scrollH - 20, 0);
        const visibleMax = visibleMin + this.scroller.width + 20;
        this.dail.range.min = visibleMin;
        this.dail.range.max = visibleMax;
        this.steps.range.min = visibleMin;
        this.steps.range.max = visibleMax;
        this.bgmTrks.range.min = visibleMin;
        this.bgmTrks.range.max = visibleMax;
        this.voiceTrks.range.min = visibleMin;
        this.voiceTrks.range.max = visibleMax;
        this.soundTrks.range.min = visibleMin;
        this.soundTrks.range.max = visibleMax;
    }

    _updateScrollerBar(){
        this.scrollerBar.y = this.fixedH - STEPLINE_HEIGHT
        this.scrollerBar.resize(this.fixedW, STEPLINE_HEIGHT);
        this.scrollerBar.setPercentParams(this.scroller.viewport.width, this.scroller.width, this.scroller.scrollH);
        const y = 3;
        const thumb = this.scrollerBar.thumb;
        thumb.cornerRadius = 3;
        thumb.y = y;
        thumb.height = STEPLINE_HEIGHT - 2 * y;
    }

    resize(w, h) {
        this.fixedW = w;
        this.fixedH = h;

        this.scroller.width = w - ICON_W;
        this._updateDrawRange();
        this._updateScrollerBar();

        // 只显示1条音轨的高度
        const bgH = AudioConst.AUDIO_STEP_H + AudioConst.AUDIO_SPLIT_LINE_H + AudioConst.AUDIO_TRK_H;
        this.rightBgRect.width = w;
        this.rightBgRect.height = bgH;

        this.iconBgRect.width = ICON_W;
        this.iconBgRect.height = bgH;

        // 只绘制1条分割线（步骤轨道和音轨之间）
        this.splitLine1.clear();
        this.splitLine1.lineStyle(1, 0x696969, 1);
        this.splitLine1.moveTo(0, 0);
        this.splitLine1.lineTo(w, 0);
        this.splitLine1.moveTo(20, -AudioConst.AUDIO_STEP_H);
        this.splitLine1.lineTo(20, AudioConst.AUDIO_TRK_H + 1.5);

        // 第2、3条分割线隐藏
        this.splitLine2.clear();
        this.splitLine3.clear();
    }

    /**
     * 音轨图标点击事件处理
     * 点击后全选/取消全选当前音轨上的所有片段
     */
    _onTrackIconClick() {
        const activeTrk = this.allTrks[this.activeTrkIndex];
        if(!activeTrk) {
            return;
        }

        // 判断当前是否已经全选
        const totalCount = activeTrk.canvas.children.length;
        const selectedCount = activeTrk.selected.length;
        
        if(selectedCount === totalCount && totalCount > 0) {
            // 已经全选，执行取消全选
            activeTrk.unselectAll();
            console.log('取消全选音轨片段');
        } else {
            // 未全选，执行全选
            activeTrk.selectAll();
        }
    }

    _addIcon(res, x, y){
        const img = new PIXI.Sprite();
        img.texture = PGlobal.resources.mainUI.textures[res];
        this.addChild(img);

        img.x = x - img.width / 2;
        img.y = y - img.height / 2;
        
        return img;
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/AudioLine.js